import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _, { indexBy } from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from "../../labels/interviewProcess_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import {
    getAdvertisementsList,
    getExamslistByAdvertisementId,
    getPostCriteriaByAdvertisementId
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getRecommendationVigatvari } from "../../actions/interviewProcessActions";
import {
    getYearList,
    getMainsAdvertisements,
} from "../../../common/actions/commonActions";

const VigatvariReport = () => {
    const pdfRef = useRef(null);

    const { register, handleSubmit, errors, reset } = useForm({
        mode: "onChange",
    });


    let { advertisementList, examList, postcriterialisting } = useSelector(
        (state) => state.postExamProcessObjectReducer,
        shallowEqual
    );
    let { yearList, getMainsAdvertisement } = useSelector(
        (state) => state.common,
        shallowEqual
    );
    let { getRecommendationVigatvariData } = useSelector(
        (state) => state.interviewProcessReducer,
        shallowEqual
    );

    const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
    const [selectedExam, setSelectedExam] = useState("");
    const [selectedPostCriteria, setSelectedPostCriteria] = useState("");
    const [reloadItem, setReloadItem] = useState(true);
    const [saveButtonFlag, setSaveButtonFlag] = useState(true);
    const [confirmClicked, setConfirmClicked] = useState(false);
    const [printFlag, setPrintFlag] = useState(true);
    const [recommendationVigatvariData, setRecommendationVigatvariData] = useState([]);
    const [selectedYear, setSelectedYear] = useState("")
    const session = JSON.parse(sessionStorage.getItem("session"));
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0)
        dispatch(getYearList());
        setReloadItem(!reloadItem);
        onCancelButton();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (getRecommendationVigatvariData.recoVigatvariList) {
            setRecommendationVigatvariData(getRecommendationVigatvariData.recoVigatvariList);
        }
        else {
            setRecommendationVigatvariData([])
        }
    }, [getRecommendationVigatvariData.recoVigatvariList]);

    useEffect(() => {
        if (getRecommendationVigatvariData.recoVigatvariList) {
            setRecommendationVigatvariData(getRecommendationVigatvariData.recoVigatvariList);
        } else {
            setRecommendationVigatvariData([]);
        }
    }, [getRecommendationVigatvariData.recoVigatvariList]);

    useEffect(() => {
        setPrintFlag(recommendationVigatvariData.length === 0);
    }, [recommendationVigatvariData]);

    const onAdvertisementChange = (ele) => {
        setSelectedAdvertNo(ele);
        setSelectedExam("");
        setSelectedPostCriteria("");
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        examList.length = 0;
        recommendationVigatvariData.length = 0;
        if (postcriterialisting) {
            postcriterialisting.length = 0;
        }
        ele && dispatch(getExamslistByAdvertisementId(ele));
        setReloadItem(!reloadItem);
    };

    const onSelectYear = (ele) => {
        // if (ele == "") {
        //     onCancelButton();
        // } else {
        let selectedValue = ele;
        setSelectedYear(selectedValue);
        selectedValue && dispatch(getMainsAdvertisements(selectedValue));
        if (getMainsAdvertisement) {
            getMainsAdvertisement.length = 0;
        }
        if (examList) {
            examList.length = 0;
        }
        if (postcriterialisting) {
            postcriterialisting.length = 0;
        }
        setSaveButtonFlag(true);
        setRecommendationVigatvariData([]);
        setReloadItem(!reloadItem);
        // }
    };

    const onExamChange = (ele) => {
        setSelectedExam(ele);
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        dispatch(getPostCriteriaByAdvertisementId(selectedAdvertNo));
        setReloadItem(!reloadItem);
        recommendationVigatvariData.length = 0;
        if (postcriterialisting) {
            postcriterialisting.length = 0;
        }
    };

    const onPostCriteriaChange = (ele) => {
        setSelectedPostCriteria(ele);
        setSaveButtonFlag(false);
        setConfirmClicked(false);
        setPrintFlag(false);
        setReloadItem(!reloadItem);
        recommendationVigatvariData.length = 0;
        setReloadItem(!reloadItem);
    };

    const onCancelButton = () => {
        setSelectedAdvertNo("");
        setSelectedExam("");
        setSelectedPostCriteria("");
        setSaveButtonFlag(true);
        setConfirmClicked(false);
        setPrintFlag(true);
        setRecommendationVigatvariData([]);
        setReloadItem(!reloadItem);
        if (getMainsAdvertisement) {
            getMainsAdvertisement.length = 0;
        }
        examList.length = 0;
        if (postcriterialisting) {
            postcriterialisting.length = 0;
        }
        reset();
    };

    const onSubmit = () => {
        dispatch(getRecommendationVigatvari(selectedAdvertNo, selectedExam, selectedPostCriteria, setPrintFlag));
        setReloadItem(!reloadItem);
    };

    const genPdf = () => {
        let headerDiv =
            '<div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' +
            label.MPSC +
            "</h5><h5>" +
            getRecommendationVigatvariData.examName +
            "</h5><h5>" +
            label.VIGATVARIREPORT +
            "</h5><h5>" +
            label.VIGATVARIREPORT2 +
            "</h5><h5>" +
            getRecommendationVigatvariData.postCriteriaName +
            "</h5></div>";
        const htmlContent = document.createElement("div");
        htmlContent.innerHTML = headerDiv;
        htmlContent.innerHTML += pdfRef.current.innerHTML;
        const examName = getRecommendationVigatvariData.examName;

        const options = {
            margin: [0.8, 0.4, 0.8, 0.4],
            filename: "VigatvariReport.pdf",
            image: { type: "jpeg", quality: 0.95 },
            html2canvas: { scale: 3, dpi: 300, letterRendering: true },
            jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "portrait",
                compressPDF: true,
            },
        };

        html2pdf()
            .from(htmlContent)
            .set(options)
            .toPdf()
            .get("pdf")
            .then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);

                    const pageWidth = pdf.internal.pageSize.getWidth();
                    const pageHeight = pdf.internal.pageSize.getHeight();
                    const textWidth =
                        (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
                        pdf.internal.scaleFactor;
                    const textX = pageWidth - textWidth - 1;
                    const textY = 0.8;
                    const currentDate = new Date();
                    const formattedDate = currentDate
                        .toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                        })
                        .split("/")
                        .join("/");
                    const dateWidth =
                        (pdf.getStringUnitWidth(formattedDate) *
                            pdf.internal.getFontSize()) /
                        pdf.internal.scaleFactor;
                    const dateX = pageWidth - dateWidth;
                    const dateY = 0.6;
                    pdf.setFontSize(8);
                    pdf.text(formattedDate, dateX, dateY);
                    pdf.text(`Page No. ${i}`, dateX, textY);

                    const ad = getRecommendationVigatvariData.advertisementNo;
                    const headerText = `Advertisement No. ${ad}`;
                    const headerX = 0.4;
                    const headerY = 0.6;

                    pdf.setFontSize(8);
                    pdf.text(headerText, headerX, headerY);
                }

                pdf.save(`VigatvariReport_${examName}.pdf`);
            });
    };

    const downloadPdf = () => {
        genPdf();
        setReloadItem(!reloadItem);
    };

    const groupByCategory = () => {
        const groupedData = {};
        recommendationVigatvariData.forEach((item) => {
            const { category, subCategory, cutoff } = item;
            if (!groupedData[category]) {
                groupedData[category] = [];
            }
            groupedData[category].push({ subCategory, cutoff });
        });
        return groupedData;
    };

    const groupedCutOffData = groupByCategory();

    return (
        <div>
            <div className="row dashboardCards">
                <div className="col-md-12">
                    <form name="importForm" encType="multipart/form-data">
                        <div className="form-group importFromSection">
                            <div className="row">
                                <div className="form-group col-md-2">
                                    <label className="float-left">
                                        {commonLabels.selectYear}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedYear"
                                        value={selectedYear}
                                        //   ref={register({ required: true })}
                                        onChange={(e) => {
                                            onSelectYear(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {yearList &&
                                            yearList.length > 0 &&
                                            yearList.map((element, index) => (
                                                <option key={index}>{element}</option>
                                                // <option key={index} value={element.id}>
                                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                // </option>
                                            ))}
                                    </select>
                                    {_.get("selectedYear.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                                <div className="form-group col-md-4">
                                    <label className="float-left">
                                        {commonLabels.SelectAdvertNo}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedAdvertiseNo1"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onAdvertisementChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {getMainsAdvertisement &&
                                            getMainsAdvertisement.length > 0 &&
                                            getMainsAdvertisement
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedAdvertiseNo1.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )}
                                </div>

                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {label.SelectExam}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedExam"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onExamChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {examList &&
                                            examList.length > 0 &&
                                            examList
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedExam.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>

                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {label.PostCriteria}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedPostCriteria"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onPostCriteriaChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {postcriterialisting &&
                                            postcriterialisting.length > 0 &&
                                            postcriterialisting
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedPostCriteria.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )}
                                </div>
                            </div>

                            <div className="row">
                                <div className="form-group col-md-8">
                                    {(session.roleName == "superadmin" ||
                                        session.roleName == "secretary" ||
                                        session.roleName == "desk officer") && (
                                            <>
                                                {" "}
                                                <button
                                                    type="reset"
                                                    className="btn btn-secondary mr-2"
                                                    onClick={() => onCancelButton()}
                                                >
                                                    {commonLabels.BUTTON_CANCEL}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary mr-2"
                                                    disabled={saveButtonFlag}
                                                    onClick={handleSubmit((e) => {
                                                        onSubmit(e);
                                                        setConfirmClicked(true);
                                                    })}
                                                >
                                                    {commonLabels.BUTTON_VIEW}
                                                </button>
                                            </>
                                        )}
                                    {(session.roleName == "superadmin" ||
                                        session.roleName == "secretary") && (
                                            <button
                                                type="button"
                                                className="btn btn-primary mr-2"
                                                disabled={printFlag || !confirmClicked}
                                                onClick={() => {
                                                    downloadPdf();
                                                }}
                                            >
                                                {commonLabels.BUTTON_PRINT}
                                            </button>
                                        )}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>


            {selectedPostCriteria && recommendationVigatvariData && recommendationVigatvariData.length > 0 && (
                <div ref={pdfRef} className="answerKeyTable" id="cutOff">
                    <table className="table table-bordered text-center">
                        <thead className="thead-light bold-label">
                            <tr>
                                <th className="col-2 text-left">CATEGORY</th>
                                <th className="col-2">ADVERTISED POSTS</th>
                                <th className="col-4">NO.OF CANDIDATES ELIGIBLE FOR RECOMMENDATION</th>
                                <th className="col-4">NO.OF CANDIDATES ELIGIBLE FOR RECOMMENDATION AS PER THEIR ORIGINAL CATEGORY</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getRecommendationVigatvariData.recoVigatvariList.map((item, index) => (
                                <tr key={index}>
                                    <td className="text-left">{item.category}</td>
                                    <td>{item.advertisedPosts}</td>
                                    <td>{item.eligibleCandidates}</td>
                                    <td>{item.eligiblePerOriginalCategory}</td>
                                </tr>
                            ))}
                            <tr>
                                <td className="bold-label">TOTAL</td>
                                <td className="bold-label">{getRecommendationVigatvariData.totalAdvPosts}</td>
                                <td className="bold-label">{getRecommendationVigatvariData.totalEligCandidates}</td>
                                <td className="bold-label">{getRecommendationVigatvariData.totalEligPerOrigCategory}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            )}
        </div>
    );
};

export default VigatvariReport;
